import { initialFormData } from '../constants/formInitialData';
import type { FormData, OccupantEntry } from '../types/form';

export function normalizeFormData(raw: unknown): FormData {
  if (!raw || typeof raw !== 'object') {
    return { ...initialFormData };
  }
  const o = raw as Record<string, unknown>;
  const occ = o.occupant_list;
  return {
    ...initialFormData,
    ...o,
    occupant_list: Array.isArray(occ) ? (occ as OccupantEntry[]) : [],
  } as FormData;
}
